import { Routes } from '@angular/router'

export const APP_ROUTES: Routes = [
  { path: '', loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./pages/admin/admin.module')['AdminModule']);  });}) },
  { path: '', loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./pages/auth/auth.module')['AuthModule']);  });}) },
  { path: 'interactive', loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./pages/interactive/interactive-preview.module')['InteractivePreviewModule']);  });}) },
  { path: 'webview', loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./pages/webview/webview.module')['WebviewModule']);  });})}
]


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/app.routes.ts